import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  finestra: {
    maxWidth: 500,
  },
  titolo: {
    paddingRight: theme.spacing(7),
  },
  chiudi: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  testo: {
    color: theme.palette.text.secondary,
  },
  azioni: {
    padding: theme.spacing(1.5, 2),
  },
}));

/**
 * Asks before a service that was on is switched off (Figma "BSS-1089 ·
 * Feedback"). Not TwoActionsAlertDialog: its red and green actions are not the
 * mock's, which uses the brand colour for both. Closing from the X or the
 * backdrop is the same as Annulla.
 */
const ConfermaDisattivazioneDialog = ({ aperta, onAnnulla, onConferma }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={aperta}
      onClose={onAnnulla}
      fullWidth
      classes={{ paper: classes.finestra }}
      aria-labelledby="conferma-disattivazione-titolo"
    >
      <DialogTitle className={classes.titolo}>
        {/* The name of the dialog is the question, without the X beside it. */}
        <span id="conferma-disattivazione-titolo">
          Disattivare il promemoria scadenze?
        </span>
        <IconButton
          aria-label="Chiudi"
          onClick={onAnnulla}
          className={classes.chiudi}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" component="p" className={classes.testo}>
          Per questo esercizio non partiranno più email di scadenza. Potrai
          riattivarlo in qualsiasi momento.
        </Typography>
      </DialogContent>
      <DialogActions className={classes.azioni}>
        <Button type="button" color="primary" onClick={onAnnulla}>
          Annulla
        </Button>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={onConferma}
        >
          Disattiva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfermaDisattivazioneDialog.propTypes = {
  aperta: PropTypes.bool.isRequired,
  onAnnulla: PropTypes.func.isRequired,
  onConferma: PropTypes.func.isRequired,
};

export default ConfermaDisattivazioneDialog;
